export default __webpack_public_path__ + "static/media/regulatory--pedestrians-push-button--g2.fcfd976d.png";